<bread-crumb></bread-crumb>

<h2 class="v_center">
    <button mat-icon-button [routerLink] = "['/dashboard/admin/users']" class="f_left">
        <mat-icon>arrow_back</mat-icon>
    </button>
    {{ 'users.manage' | translate }} 
</h2>


<mat-card class="card ">
  <mat-card-content class="card-content">
   <form #f = "ngForm">
         <div fxLayout="row" >

            <mat-form-field fxFlex = "10">
              <mat-label translate> users.username </mat-label>
              <input  matInput  type="text" required placeholder="" [(ngModel)]="user.username" name="name">
            </mat-form-field>

            <mat-form-field fxFlex = "15" fxFlexOffset="2">
              <mat-label translate> users.first_name </mat-label>
              <input  matInput  type="text"  placeholder="" [(ngModel)]="user.first_name" name="first_name">
            </mat-form-field>

            <mat-form-field fxFlex = "15" fxFlexOffset="2">
                <mat-label translate> users.last_name </mat-label>
                <input  matInput  type="text"  placeholder="" [(ngModel)]="user.last_name" name="last_name">
            </mat-form-field>

            <mat-form-field fxFlex = "15" fxFlexOffset="2">
              <mat-label translate> users.email </mat-label>
              <input  matInput  type="text"  placeholder="" [(ngModel)]="user.email" name="email">
            </mat-form-field>

            <div fxFlex = "25" fxFlexOffset="2" *ngIf="isSuperUser()">
                <mat-checkbox [(ngModel)]="user.is_superuser" name="is_superuser" [disabled] = "!isSuperUser()"> {{ "users.is_superuser" | translate }}</mat-checkbox>
            </div>

        </div>

        <div fxLayout="row">

          <mat-form-field fxFlex = "30">

            <mat-select [(ngModel)]="user.zimbra_instance.id" name="zimbra_instance_id">
              <mat-option *ngFor="let aa of zimbrainstances.all()" [value]="aa.id">
                {{ aa.code }} - {{ aa.name }}
              </mat-option>
            </mat-select>
          
          </mat-form-field>

          <div fxFlex = "10" fxFlexOffset="2">
            <button mat-raised-button color="primary" (click)="user.zimbra_instance.id = null"> 
              <mat-icon>highlight_off</mat-icon>
              {{ 'zimbrainstance.remove_association' | translate }} 
            </button>
          </div>

        </div>
        
        <!-- <div fxLayout="row"  *ngIf="isSuperUser()">
        
            <mat-form-field fxFlex = "15">
              <mat-label translate> generic.password </mat-label>
              <input  matInput  type="password" placeholder="" [(ngModel)]="user.password" name="password">
              <mat-hint> {{ 'users.password_note' | translate }} </mat-hint>
              
            </mat-form-field>
        
        </div> -->

    </form>
    <div fxLayout="row">
          <mat-card-actions class="card-actions width-field-100 t_right">
                <button mat-raised-button color="primary" (click)="save()"> 
                    <mat-icon>save</mat-icon>
                    {{ 'generic.submit' | translate }} 
                </button>
          </mat-card-actions>
    </div>

   </mat-card-content>
</mat-card>
